import React, { useMemo } from 'react';
import { shallowEqual, useSelector } from 'umi'
import Service from '@/pages/dashboard/components/PageContainer/Service';
import { formatFilterValues } from '@/pages/dashboard/utils/utils';
import moment from 'moment';

export default function WeeklyActiveUsersServiceCo(props: any) {
  const { style, className, type, config, children, ...resetProps } = props || {}
  const { api, refreshKey='', interval, filter } = config || {}
  const { rangeTime: rangeTimeConfig } = filter || {}

  const { gameCode } = useSelector((state: any) => {
    return {
      gameCode: state?.dashboard?.currentGame?.game_code,
    }
  }, shallowEqual)

  const data = useMemo(() => {
    return {
      gameCode,
    }
  }, [gameCode]);

  const isSingleWeek = (rangeTime?: any[]) => {
    if (!rangeTime || rangeTime?.length !== 2) return undefined;

    const startDate = moment(rangeTime[0]);
    const endDate = moment(rangeTime[1]);

    console.log(startDate.isSame(endDate, 'week'));
    return startDate.isSame(endDate, 'week');
  };

  const defaultTimeRange = (rangeTime?: any[]) => {
    console.log('rangeTime: ', rangeTime);
    const [, endDate] = rangeTime || [];
    const { amount, unit } = rangeTimeConfig?.subtract || {};
    if (!endDate) return rangeTime;

    const option = isSingleWeek(rangeTime) ? { endDate, amount, unit } : undefined;
    if (!option) return rangeTime;

    return [
      moment(option.endDate)
        .subtract(option.amount, option.unit as moment.unitOfTime.DurationConstructor)
        .add(1, 'day')
        .format('YYYY-MM-DD'),
      option.endDate,
    ];
  };

  return (
    <div className={className} style={style}>
      <Service
        api={api}
        data={data}
        refreshKey={refreshKey}
        interval={interval}
        dataKey={'weekData'}
        beforeRequest={(data) => {
          const { filterVal, gameCode } = data;
          const { timeType, rangeTime, ...filters } = filterVal || {};
          const rangeTimeArr = rangeTimeConfig?.subtract ? defaultTimeRange(rangeTime) : rangeTime;

          const params = {
            game_code: gameCode,
            start_time: rangeTimeArr?.[0] || '',
            end_time: rangeTimeArr?.[1] || '',
            // period: PERIODTIMEOBJ[timeType] || 'daily',
            filters: formatFilterValues(filters),
          }
          return params
        }}
        trackData={['gameCode']}>
        {React.Children.map(children, (child: any) => {
          return React.cloneElement(
            child,
            {
              ...resetProps,
              state: {}
            }
          );
        })}
      </Service>
    </div>
  );
};
